import {computed, ref} from "vue";
import {useGivingTreeStore} from '@/store/givingTree'

export default function useComputedTreeValue() {
    const givingTreeStore = useGivingTreeStore()
    const hookId = ref()

    const getActiveHookId = (newHookId: string) => hookId.value = newHookId

    const getComputedText = computed({
        get() {
            if (hookId.value) {
                const widget = givingTreeStore.getWidgetValue(hookId.value)

                if (widget) {
                    if (widget.type === 'meta') {
                        return widget.textValue
                    } else {
                        return widget.name
                    }
                }
            } else {
                return '<Model Text>'
            }
        },
        set(val) {
            setComputedText(val)
        }
    })

    const getOverrideText = computed({
        get() {
            if (hookId.value) {
                const widget = givingTreeStore.getWidgetValue(hookId.value)

                if (widget) {
                    if (widget.type === 'meta') {
                        return widget.overrideValue
                    } else {
                        return widget.name
                    }
                }
            } else {
                return '<Model Text>'
            }
        },
        set(val) {
            setComputedText(val)
        }
    })

    const setComputedText = (val: any, hook?: string) => {
        const hookIdValue = hookId.value ? hookId.value : hook
        givingTreeStore.setWidgetValue(hookIdValue, val);
    };




    const getComputedValue = computed({
        get() {
            if (hookId.value) {
                if (givingTreeStore.getWidgetValue(hookId.value)) {
                    if (givingTreeStore.getWidgetValue(hookId.value).value) {
                        return givingTreeStore.getWidgetValue(hookId.value).value
                    } else {
                        return 0
                    }
                }
            } else {
                return null
            }
        },
        set(val) {
            setComputedValue(val)
        }
    })

    const getOverrideValue = computed({
        get() {
            if (hookId.value) {
                if (givingTreeStore.getWidgetValue(hookId.value)) {
                    return givingTreeStore.getWidgetValue(hookId.value).overrideValue
                }
            } else {
                return null
            }
        },
        set(val) {
            setComputedValue(val)
        }
    })


    const getComputedChoices = computed({
        get() {
            if (hookId.value) {
                return givingTreeStore.getWidgetValue(hookId.value).choices
            }
        },
        set(val) {
        }
    })

    const getComputedChoiceId = computed({
        get() {
            if (hookId.value) {
                return givingTreeStore.getWidgetValue(hookId.value)?.selectedChoiceId
            }
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).selectedChoiceId = val
        }
    })

    const getOverrideComputedChoiceId = computed({
        get() {
            if (hookId.value) {
                return givingTreeStore.getWidgetValue(hookId.value)?.overrideSelectedChoiceId
            }
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).overrideSelectedChoiceId = val
        }
    })

    const getComputedChoiceName = computed({
        get() {
            if (hookId.value) {
                return givingTreeStore.getWidgetValue(hookId.value)?.selectedChoiceName
            }
        },
        set(val) {
        }
    })

    const getComputedType = computed({
        get() {
            if (hookId.value) {
                return givingTreeStore.getWidgetValue(hookId.value)?.variableType
            }
            return 'currency'
        },
        set(val) {
        }
    })

    const getComputedLabel = computed(() => hookId.value ? givingTreeStore.getWidgetValue(hookId.value).name : 'Computed Label')

    const getComputedPrecision = computed(() => {
        const precision = hookId.value ? givingTreeStore.getWidgetValue(hookId.value)?.precision : null;
        return precision ?? 0;
    })

    const getComputedPrecisionByHookId = (hookId) => {
        const precision = hookId ? givingTreeStore.getWidgetValue(hookId)?.precision : null
        return parseInt(precision ?? 0);
    }

    const getComputedTypeByHookId = (hookId) => {
        return hookId ? givingTreeStore.getWidgetValue(hookId)?.variableType : null
    }

    const getComputedHasFormula = (hookId) => {
        return hookId ? givingTreeStore.getWidgetValue(hookId)?.hasFormula : false
    }

    const getComputedFormulaSummary = (hookId) => {
        return hookId ? givingTreeStore.getWidgetValue(hookId)?.formulaSummary : null
    }

    const getComputedAssociatedRoots = (hookId) => {
        return hookId ? givingTreeStore.getWidgetValue(hookId)?.associatedRoots : null
    }

    const getComputedTextByHookId = (hookId) => {
        if (!hookId) return null

        const widget = givingTreeStore.getWidgetValue(hookId)

        if (widget) {
            if (widget.type === 'meta') {
                return widget.textValue
            } else {
                return widget.name
            }
        } else {
            return null
        }
    }

    const getValueByHookId = (hookId) => {
        if (hookId) {
            if (givingTreeStore.getWidgetValue(hookId)) {
                if (givingTreeStore.getWidgetValue(hookId).value) {
                    return givingTreeStore.getWidgetValue(hookId).value
                } else {
                    return 0
                }
            }
        } else {
            return null
        }
    }


    const getComputedMinMax = computed(() => {
        if (hookId.value) {
            if (givingTreeStore.getWidgetValue(hookId.value)?.hasRange) {
                return {
                    min: givingTreeStore.getWidgetValue(hookId.value)?.min ?? 0,
                    max: givingTreeStore.getWidgetValue(hookId.value)?.max ?? 100
                }
            }

        }

        return null
    })

    const getComputedReadOnly = computed(() => hookId.value ? givingTreeStore.getWidgetValue(hookId.value).readOnly : false)

    const getComputedSource = computed({

        get() {
            return hookId.value ? givingTreeStore.getWidgetValue(hookId.value)?.source : null
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).source = val
        }
    })

    const getComputedMessage = computed({

        get() {
            return hookId.value ? givingTreeStore.getWidgetValue(hookId.value)?.message : null
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).message = val
        }
    })

    const getComputedNotes = computed({
        get() {
            return hookId.value ? givingTreeStore.getWidgetValue(hookId.value)?.notes : null
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).notes = val
        }
    })

    const getNotesByHookId = (hookId: string) => {
        return hookId ? givingTreeStore.getWidgetValue(hookId)?.notes : null
    }

    const getOverrideNotes = computed({
        get() {
            return hookId.value ? givingTreeStore.getWidgetValue(hookId.value)?.overrideNotes : null
        },
        set(val) {
            givingTreeStore.getWidgetValue(hookId.value).notes = val
        }
    })

    const setComputedValue = (val: any, hook?: string) => {
        const hookIdValue = hookId.value ? hookId.value : hook
        givingTreeStore.setWidgetValue(hookIdValue, val);
    };


    return {
        getActiveHookId,
        getComputedValue,
        getOverrideValue,
        getValueByHookId,
        getComputedText,
        getOverrideText,
        getComputedType,
        getComputedTypeByHookId,
        getComputedLabel,
        setComputedValue,
        getComputedPrecision,
        getComputedPrecisionByHookId,
        getComputedMinMax,
        getComputedReadOnly,
        getComputedSource,
        getComputedNotes,
        getOverrideNotes,
        getComputedChoices,
        getComputedChoiceId,
        getComputedChoiceName,
        getComputedMessage,
        getComputedFormulaSummary,
        getComputedHasFormula,
        getComputedAssociatedRoots,
        getComputedTextByHookId,
        getOverrideComputedChoiceId,
        getNotesByHookId
    }
}
